module.exports = __webpack_public_path__ + "static/media/Montserrat-BoldItalic.616c74c7.ttf";